import styled from "styled-components";

const Footerend = styled.div`
@media (min-width: 1280px)
 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}
@media (min-width: 768px)
{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}

    font-size: .875rem;
    line-height: 1.25rem;


    padding-top: 1.25rem;
    padding-bottom: 1.25rem;


    padding-left: 1.25rem;
    padding-right: 1.25rem;


    border-top: 1px solid rgba(0,0,0,.1);


    justify-content: space-between;


    align-items: center;


    flex-direction: row;


    display: flex;

    box-sizing: border-box;

    font-family: sans-serif;
` 
const Copyright = styled.p`

    --tw-text-opacity: 1;
    color: rgba(97,97,97,var(--tw-text-opacity));


    letter-spacing: -0.025em;


    line-height: 1.625;



    letter-spacing: -0.025em;


    margin: 0;

`
const EndDiv = styled.div`

    --tw-text-opacity: 1;
    color: rgba(66,66,66,var(--tw-text-opacity));


    align-items: center;


    flex-direction: row;


    display: flex;

`
export const Footer = () => {

    return(
        <Footerend>
            <Copyright>© 2021 LinearBytes Inc.</Copyright>
            <EndDiv ><div style={{display:"inline-block"}}>Privacy Policy</div><div style={{display:"inline-block",marginLeft:"1.25rem"}}>Terms</div></EndDiv>
        </Footerend>
    )
} 